import styled from 'styled-components';

export const PopupBody = styled.div`
  font-family: system-ui;
  background: #FFFFFF;
  border-radius: 3px;
  box-shadow: 0 10px 20px 2px rgba(9,30,66,0.10);
  box-sizing: border-box;
  max-height: 317.5px;
`;

export const Trigger = styled.div`
  width: ${props => props.width || '100%'};
`;
